import React from "react";

const AreaHeader = ({}) => {
    return (
        <div className='area-header'>

        </div>
    );
};

export default AreaHeader;
